export default __webpack_public_path__ + "static/media/groups.7f38e117.svg";